import { TabsComponent } from '@noorden-insurtech/alba-design-system';
import type { ReactNode } from 'react';

export type TabItem<TValue extends string> = {
  value: TValue;
  label: ReactNode;
};

export type TabsProps<TValue extends string> = {
  value: TValue;
  onValueChange: (value: TValue) => void;
  items: TabItem<TValue>[];
  /** Os `TabPanel`s, um por item. */
  children: ReactNode;
};

/**
 * Abas. Envolve o `TabsComponent` do design system, que está saindo: features
 * importam daqui, nunca do pacote. O conteúdo de cada aba vai num `TabPanel`
 * com o mesmo `value` do item.
 */
export function Tabs<TValue extends string>({
  value,
  onValueChange,
  items,
  children,
}: TabsProps<TValue>) {
  return (
    <TabsComponent.Root
      value={value}
      onValueChange={details => onValueChange(details.value as TValue)}
    >
      <TabsComponent.List>
        {items.map(item => (
          <TabsComponent.Trigger key={item.value} value={item.value}>
            {item.label}
          </TabsComponent.Trigger>
        ))}
      </TabsComponent.List>
      {children}
    </TabsComponent.Root>
  );
}

export type TabPanelProps = {
  value: string;
  children: ReactNode;
};

export function TabPanel({ value, children }: TabPanelProps) {
  return (
    <TabsComponent.Content value={value}>{children}</TabsComponent.Content>
  );
}
